<section class="bg bg-no-repeat bg-optout-banner bg-cover px-30 py-10 flex flex-col bg-right text-white">
  <div class="max-w-1440 mx-auto h-full w-full flex justify-between items-center">
    <p class="font-bold">Want to switch back to the old Alphastar Portal view?</p>
    <button class="button is-primary is-outlined is-sm border-white text-white" mat-button (click)="optOutOfNewPortal()">Return to old portal</button>
  </div>
</section>